import http from '../../../../../api/http';

const BASE_URL = '/mypage/jobFair';
const API_URL = `${BASE_URL}/Resume`;

// 입사지원 시 이력서 리스트 페이징 조회
function retrieveResumeListPagingByJobNoticeSeq(params) {
    return http.post(`${API_URL}/retrieveResumeListPagingByJobNoticeSeq`, params)
}

// 인재정보 리스트 조회
function retrieveAllResumePaging(params) {
    return http.post(`${API_URL}/retrieveAllResumePaging`, params)
}

// 인재정보 리스트 조회(암호화 마스킹)
function retrieveAllResumePagingWithMasking(params) {
    return http.post(`${API_URL}/retrieveAllResumePaging2`, params)
}

// 인재정보 리스트 엑셀다운로드
function retrieveAllResumeExcel(params) {
    return http.post(`${API_URL}/retrieveAllResumeExcel`, params, {
        responseType: 'blob',
    })
}

// 이력서 상세보기
function retrieveResume(resumeId) {
    return http.get(`${API_URL}/retrieveResume?resumeId=${resumeId}&hidden=0`)
}

// 이력서 등록
function createResume(params) {
    return http.post(`${API_URL}/createResume`, params)
}

// 이력서 수정
function updateResume(params) {
    return http.post(`${API_URL}/updateResume`, params)
}

// 이력서 삭제
function deleteResume(params) {
    return http.post(`${API_URL}/deleteResume`, params)
}

// 이력서 파일 등록
function createResumeFile(params) {
    return http.post(`${API_URL}/createResumeFile`, params)
}

// 면접제안 채용공고 리스트 조회
function retrieveJobNoticeListPagingWithResumeId(params) {
    return http.post(`${BASE_URL}/jobNotice/retrieveJobNoticeListPagingWithResumeId`, params)
}

// 내 이력서 목록 조회
function retrieveResumeListPaging(params) {
    return http.post(`${API_URL}/retrieveResumeListPaging`, params)
}

// 이력서 공개/비공개
function updateStatusResumeResOpenYn(params) {
    return http.post(`${API_URL}/updateStatusResumeResOpenYn`, params)
}

// 인재정보 공개여부 체크 
function retrieveResumeResOpenYn(userId) {
    return http.get(`${API_URL}/retrieveResumeResOpenYn?userId=${userId}`)
}

// 이력서 입사지원 여부 체크
function retrieveResumeApplicantYn(resumeId) {
    return http.get(`${API_URL}/retrieveResumeApplicantYn?userId=${resumeId}`)
}

export default {
    retrieveResumeListPagingByJobNoticeSeq,
    retrieveAllResumePaging,
    retrieveAllResumePagingWithMasking,
    retrieveAllResumeExcel,
    retrieveResume,
    createResume,
    updateResume,
    deleteResume,
    createResumeFile,
    retrieveJobNoticeListPagingWithResumeId,
    retrieveResumeListPaging,
    updateStatusResumeResOpenYn,
    retrieveResumeResOpenYn,
    retrieveResumeApplicantYn,
};